<template>
  <div>
    <!-- <el-card class="box-card" v-w-watermark="{ label: '兄弟高科技(深圳)有限公司' }"
      style="width: 90%; margin: 30px auto; padding: 0; text-align: center;"> -->
    <el-card class="box-card"  style="width: 90%; margin: 30px auto; padding: 0; text-align: center;">
      <!-- <div slot="header" class="clearfix">
          <h2> 招工、招聘信息采集</h2>
        </div> -->
      <div class="titleCss">
        <span class="forntCss">
          面试报名表
        </span>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="申请职位" prop="position">
              <el-select v-model="form.position" placeholder="请选择申请职位" @change="positionChange" clearable style="width: 100%;">
                <el-option v-for="position in positions" :key="position.id" :label="position.name"
                  :value="position.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="面试日期" prop="interViewDate">
              <el-date-picker v-model="form.interViewDate" :editable="false" value-format="YYYYMMDD" placeholder="请选择日期"
                type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <transition-group name="moveCartoon" appear>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="positionKey != 1">
              <el-form-item label="希望薪金" prop="hopeSalary">
                <div class="mo-input--number">
                  <el-input-number style="width: 100%;" v-model="form.hopeSalary" :min="0" :max="9999999999"
                    placeholder="请输入希望薪金" :precision="2" :controls="false">
                  </el-input-number>
                  <div class="define-append">元</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="positionKey != 1">
              <el-form-item label="可上班日期" prop="workDate">
                <el-date-picker v-model="form.workDate" value-format="YYYYMMDD" placeholder="请选择日期"
                  :disabled-date="disabledBefor" type="date" :editable="false" style="width: 100%;"
                  clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </transition-group>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="姓名" prop="name">
              <el-input @blur="form.name = $event.target.value.trim()" v-model="form.name" placeholder="请输入姓名"
                maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="姓名拼音" prop="pinyin">
              <el-input @blur="form.pinyin = $event.target.value.trim()" v-model="form.pinyin" placeholder="请输入姓名拼音"
                maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择性别" clearable>
                <el-option v-for="sex in sexs" :key="sex.id" :label="sex.name" :value="sex.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="民族" prop="nationality">
              <el-select clearable v-model="form.nationality" placeholder="请选择民族">
                <el-option v-for="nationality in nationalityOptions" :key="nationality.id" :label="nationality.name"
                  :value="nationality.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="婚姻状况" prop="marriage">
              <el-select v-model="form.marriage" placeholder="请选择婚姻状况" clearable>
                <el-option v-for="marriage in marriages" :key="marriage.id" :label="marriage.name"
                  :value="marriage.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="出生年月" prop="birthDay">
              <el-date-picker v-model="form.birthDay" disabled :editable="false" value-format="YYYYMMDD"
                placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="身高">
              <div class="mo-input--number">
                <el-input-number style="width: 100%;" v-model="form.height" :min="0" :max="999" placeholder="请输入身高"
                  :precision="0" :controls="false">
                </el-input-number>
                <div class="define-append">cm</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="视力">
              <!-- <el-input-number style="width: 100%;" v-model="form.vision" :min="0" :max="99" placeholder="请输入视力"
                :precision="2" :controls="false">
              </el-input-number> -->
              <el-input @blur="form.vision = $event.target.value.trim()" v-model="form.vision" placeholder="请输入视力"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="籍贯" prop="native">
              <!-- <el-cascader
                expand-trigger="hover"
                clearable
                separator=""
                :options="native"
                v-model="form.native"
              ></el-cascader> -->
              <el-select v-model="form.native" clearable filterable :filter-method="pinyinFilterMethod"
                placeholder="请输入籍贯" style="width: 100%;">
                <el-option v-for="citie in cities" :key="citie.id" :label="citie.name" :value="citie.name"></el-option>
              </el-select>
              <!-- <el-input @blur="form.native = $event.target.value.trim()" v-model="form.native" placeholder="请输入籍贯"
                maxlength="20"></el-input> -->
            </el-form-item>
          </el-col>
          <transition name="moveCartoon" appear>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="positionKey != 1">
              <el-form-item label="党员">
                <el-select v-model="form.partyMember" placeholder="请选择" clearable>
                  <el-option :key="1" label="是" value="是"></el-option>
                  <el-option :key="2" label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </transition>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="色盲">
              <el-input @blur="form.blindness = $event.target.value.trim()" v-model="form.blindness" placeholder="请输入色盲"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model.trim="form.phone" placeholder="请输入手机号码" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="身份证号码" prop="identifyNum">
              <el-input v-model.trim="form.identifyNum" placeholder="请输入身份证号码" maxlength="18"
                @blur="setBirthDay"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="联系地址" prop="contactAddress">
              <el-input @blur="form.contactAddress = $event.target.value.trim()" v-model="form.contactAddress"
                placeholder="请输入联系地址" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="派遣公司" prop="dispatchCompany">
              <el-select v-model="form.dispatchCompany" clearable placeholder="请选择派遣公司" style="width: 100%;">
                <el-option v-for="company in companies" :key="company.id" :label="company.name"
                  :value="company.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row :gutter="10"> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="身份证地址" prop="identifyAddr">
              <el-input @blur="form.identifyAddr = $event.target.value.trim()" v-model="form.identifyAddr"
                placeholder="请输入身份证地址" maxlength="50"></el-input>
            </el-form-item>
          </el-col> -->
        <!-- </el-row> -->
        <el-divider></el-divider>
        <div class="titleCss" style="height: 80px;">
          <span class="forntCss">
            受教育情况
          </span>
          <p style="line-height: 10px; font-size: 10px; color: red;">(从最高学历开始填写)</p>
        </div>
        <transition name="moveCartoon" appear>
          <el-row :gutter="10" v-if="positionKey != 1">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="外语水平" prop="languageLevel">
                <el-input @blur="form.languageLevel = $event.target.value.trim()" v-model="form.languageLevel"
                  placeholder="请输入外语水平,没有请填无" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="计算机水平" prop="computerSkill">
                <el-select v-model="form.computerSkill" placeholder="请选择计算机水平" clearable>
                  <el-option v-for="computerSkill in computerSkills" :key="computerSkill.id" :label="computerSkill.name"
                    :value="computerSkill.name"></el-option>
                </el-select>
                <!-- <el-input @blur="form.computerSkill = $event.target.value.trim()" v-model="form.computerSkill"
                  placeholder="请输入计算机水平,没有请填无" maxlength="50"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="资格证书" prop="certificate">
                <el-input @blur="form.certificate = $event.target.value.trim()" v-model="form.certificate"
                  placeholder="请输入资格证书,没有请填无" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </transition>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="毕业院校" prop="college1">
              <el-input @blur="form.college1 = $event.target.value.trim()" v-model="form.college1"
                placeholder="请输入毕业院校,没有请填无" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="起止日期" prop="startEnd1">
              <el-date-picker v-model="form.startEnd1" popper-class="picker-down" :popper-append-to-body="false"
                unlink-panels type="daterange" :editable="false" :disabled-date="disabledDate" value-format="YYYYMMDD"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="开始日期" prop="start1">
              <el-date-picker v-model="form.start1" :editable="false" :disabled-date="disabledDate"
                value-format="YYYYMMDD" placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="结束日期" prop="end1">
              <el-date-picker v-model="form.end1" :editable="false" :disabled-date="disabledDate" value-format="YYYYMMDD"
                placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="专业" prop="major1">
              <el-input @blur="form.major1 = $event.target.value.trim()" v-model="form.major1" placeholder="请输入专业"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="学历" prop="academic1">
              <el-select clearable v-model="form.academic1" placeholder="请选择学历">
                <el-option v-for="academic in academics" :key="academic.id" :label="academic.name"
                  :value="academic.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="受教育方式" prop="eduMethod1">
              <el-select clearable v-model="form.eduMethod1" placeholder="请选择受教育方式">
                <el-option v-for="eduMethod in eduMethods" :key="eduMethod.id" :label="eduMethod.name"
                  :value="eduMethod.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <transition-group name="moveCartoon" appear>
          <el-row :gutter="10" v-if="addcollege">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="毕业院校" prop="college2">
                <el-input @blur="form.college2 = $event.target.value.trim()" v-model="form.college2" placeholder="请输入毕业院校"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="起止日期" prop="startEnd2">
                <el-date-picker v-model="form.startEnd2" type="daterange" :editable="false" :disabled-date="disabledDate"
                  popper-class="picker-down" :popper-append-to-body="false" unlink-panels value-format="YYYYMMDD"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="开始日期" prop="start2">
                <el-date-picker v-model="form.start2" :editable="false" :disabled-date="disabledDate"
                  value-format="YYYYMMDD" placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="结束日期" prop="end2">
                <el-date-picker v-model="form.end2" :editable="false" :disabled-date="disabledDate"
                  value-format="YYYYMMDD" placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="addcollege">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="专业" prop="major2">
                <el-input @blur="form.major2 = $event.target.value.trim()" v-model="form.major2" placeholder="请输入专业"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="学历" prop="academic2">
                <el-select clearable v-model="form.academic2" placeholder="请选择学历">
                  <el-option v-for="academic in academics" :key="academic.id" :label="academic.name"
                    :value="academic.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="受教育方式" prop="eduMethod2">
                <el-select clearable v-model="form.eduMethod2" placeholder="请选择受教育方式">
                  <el-option v-for="eduMethod in eduMethods" :key="eduMethod.id" :label="eduMethod.name"
                    :value="eduMethod.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </transition-group>
        <div class="icon-container" v-if="addcollege == false">
          <el-icon @click="() => addcollege = true">
            <Plus size="100%" />
          </el-icon>
          <span @click="() => addcollege = true" class="icon-label">添加毕业院校</span>
        </div>
        <div class="icon-container" v-if="addcollege == true">
          <el-icon @click="removeCollege">
            <Close size="100%" />
          </el-icon>
          <span @click="removeCollege" class="icon-label">删除毕业院校</span>
        </div>
        <el-divider></el-divider>
        <div class="titleCss">
          <span class="forntCss">
            工作经历
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="工作单位" prop="employer1">
              <el-input @blur="form.employer1 = $event.target.value.trim()" v-model="form.employer1"
                placeholder="请输入工作单位,没有请填无" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="起止日期" prop="workstartEnd1">
              <el-date-picker v-model="form.workstartEnd1" type="daterange" :editable="false"
                :disabled-date="disabledDate" popper-class="picker-down" :popper-append-to-body="false" unlink-panels
                value-format="YYYYMMDD" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="开始日期" prop="workStart1">
              <el-date-picker v-model="form.workStart1" :editable="false" :disabled-date="disabledDate"
                value-format="YYYYMMDD" placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="结束日期" prop="workEnd1">
              <el-date-picker v-model="form.workEnd1" :editable="false" :disabled-date="disabledDate" value-format="YYYYMMDD"
                placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="职务" prop="position1">
              <el-input @blur="form.position1 = $event.target.value.trim()" v-model="form.position1" placeholder="请输入职务"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="薪金" prop="salary1">
              <div class="mo-input--number">
                <el-input-number style="width: 100%;" v-model="form.salary1" :min="0" :max="9999999999"
                  placeholder="请输入薪金" :precision="2" :controls="false">
                </el-input-number>
                <div class="define-append">元</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="离职原因" prop="reason1">
              <el-input @blur="form.reason1 = $event.target.value.trim()" v-model="form.reason1" placeholder="请输入离职原因"
                maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="证明人" prop="provers1">
              <el-input @blur="form.provers1 = $event.target.value.trim()" v-model="form.provers1"
                placeholder="请输入证明人及联系方式" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <transition-group name="moveCartoon" appear>
          <el-row :gutter="10" v-if="addemployer">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="工作单位" prop="employer2">
                <el-input @blur="form.employer2 = $event.target.value.trim()" v-model="form.employer2"
                  placeholder="请输入工作单位" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="起止日期" prop="workstartEnd2">
                <el-date-picker v-model="form.workstartEnd2" type="daterange" :editable="false"
                  :disabled-date="disabledDate" popper-class="picker-down" :popper-append-to-body="false" unlink-panels
                  value-format="YYYYMMDD" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="开始日期" prop="workStart2">
              <el-date-picker v-model="form.workStart2" :editable="false" :disabled-date="disabledDate"
                value-format="YYYYMMDD" placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="结束日期" prop="workEnd2">
              <el-date-picker v-model="form.workEnd2" :editable="false" :disabled-date="disabledDate" value-format="YYYYMMDD"
                placeholder="请选择日期" type="date" style="width: 100%;" clearable></el-date-picker>
            </el-form-item>
          </el-col>
            
          </el-row>
          <el-row :gutter="10" v-if="addemployer">

            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="职务" prop="position2">
                <el-input @blur="form.position2 = $event.target.value.trim()" v-model="form.position2" placeholder="请输入职务"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="薪金" prop="salary2">
                <div class="mo-input--number">
                  <el-input-number style="width: 100%;" v-model="form.salary2" :min="0" :max="9999999999"
                    placeholder="请输入薪金" :precision="2" :controls="false">
                  </el-input-number>
                  <div class="define-append">元</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="离职原因" prop="reason2">
                <el-input @blur="form.reason2 = $event.target.value.trim()" v-model="form.reason2" placeholder="请输入离职原因"
                  maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="证明人" prop="provers2">
                <el-input @blur="form.provers2 = $event.target.value.trim()" v-model="form.provers2"
                  placeholder="请输入证明人及联系方式" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </transition-group>
        <div class="icon-container" v-if="addemployer == false">
          <el-icon @click="() => addemployer = true">
            <Plus size="100%" />
          </el-icon>
          <span @click="() => addemployer = true" class="icon-label">添加工作经历</span>
        </div>
        <div class="icon-container" v-if="addemployer == true">
          <el-icon @click="removeEmployer">
            <Close size="100%" />
          </el-icon>
          <span @click="removeEmployer" class="icon-label">删除工作经历</span>
        </div>
        <el-divider></el-divider>
        <div class="titleCss">
          <span class="forntCss">
            家庭资料
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="姓名" prop="relativeName1">
              <el-input @blur="form.relativeName1 = $event.target.value.trim()" v-model="form.relativeName1"
                placeholder="请输入姓名" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="关系" prop="relation1">
              <el-input @blur="form.relation1 = $event.target.value.trim()" v-model="form.relation1" placeholder="请输入关系"
                maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="地址" prop="relativeAddress1">
              <el-input @blur="form.relativeAddress1 = $event.target.value.trim()" v-model="form.relativeAddress1"
                placeholder="请输入地址" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="联系电话" prop="relativePhone1">
              <el-input v-model.trim="form.relativePhone1" placeholder="请输入联系电话" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <transition name="moveCartoon" appear>
          <el-row :gutter="10" v-if="addrelative == true">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="姓名" prop="relativeName2">
                <el-input @blur="form.relativeName2 = $event.target.value.trim()" v-model="form.relativeName2"
                  placeholder="请输入姓名" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="关系" prop="relation2">
                <el-input @blur="form.relation2 = $event.target.value.trim()" v-model="form.relation2" placeholder="请输入关系"
                  maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="地址" prop="relativeAddress2">
                <el-input @blur="form.relativeAddress2 = $event.target.value.trim()" v-model="form.relativeAddress2"
                  placeholder="请输入地址" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="联系电话" prop="relativePhone2">
                <el-input v-model.trim="form.relativePhone2" placeholder="请输入联系电话" maxlength="11"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </transition>
        <div class="icon-container" v-if="addrelative == false">
          <el-icon @click="() => addrelative = true">
            <Plus size="100%" />
          </el-icon>
          <span @click="() => addrelative = true" class="icon-label">添加家庭资料</span>
        </div>
        <div class="icon-container" v-if="addrelative == true">
          <el-icon @click="removeRelative">
            <Close size="100%" />
          </el-icon>
          <span @click="removeRelative" class="icon-label">删除家庭资料</span>
        </div>
        <el-divider></el-divider>
        <div class="titleCss">
          <span class="forntCss">
            紧急联络人
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="姓名" prop="emergencyName">
              <el-input @blur="form.emergencyName = $event.target.value.trim()" v-model="form.emergencyName"
                placeholder="请输入姓名" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="关系" prop="emergencyrelation">
              <el-input @blur="form.emergencyrelation = $event.target.value.trim()" v-model="form.emergencyrelation"
                placeholder="请输入关系" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="地址" prop="emergencyAddress">
              <el-input @blur="form.emergencyAddress = $event.target.value.trim()" v-model="form.emergencyAddress"
                placeholder="请输入地址" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item label="联系电话" prop="emergencyPhone">
              <el-input v-model.trim="form.emergencyPhone" placeholder="请输入联系电话" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="titleCss">
          <span class="forntCss">
            招聘来源
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
            <el-form-item class="checkboxCss" label="咨询信息" prop="consulting">
              <!-- <el-checkbox-group v-model="form.consulting">
                <el-checkbox v-for="consulting in consultings" :label="consulting" :key="consulting">{{ consulting
                }}</el-checkbox>
              </el-checkbox-group> -->
              <el-radio-group v-model="form.consulting">
                <el-radio v-for="consulting in consultings" :key="consulting" :label="consulting"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item label="备注" prop="remark">
              <el-input @blur="form.remark = $event.target.value.trim()" v-model="form.remark" placeholder="请输入备注"
                maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-divider></el-divider>
        <el-row>
          <div style="width: 100%;">
            <el-checkbox class="el-checkbox__label" v-model="checked1"></el-checkbox>
            <span style="font-size: 12px;">
              已仔细阅读并透彻理解
              <el-link type="primary" @click="openCommitment('InfoInstruct')">《个人信息收集告知书》</el-link>
              <!-- <el-link type="primary" @click="openCommitment('HireCondition')">《录用条件确认书》</el-link>
              <el-link type="primary" @click="openCommitment('Commitment')">及《承诺书》</el-link> -->
              里的全部内容，并同意。
            </span>
          </div>
        </el-row>
        <el-row>
          <div style="width: 100%;">
            <el-checkbox class="el-checkbox__label" v-model="checked2"></el-checkbox>
            <span style="font-size: 12px;">
              本人填写的上述信息及提交的资料真实有效；如存在虚假或伪造，本人愿意接受公司解雇，公司无须给予本人任何补偿。
            </span>
          </div>
        </el-row>
        <el-button style="margin-top: 10px;" type="primary" @click="SubmitEvent">
          生成二维码
        </el-button>
      </el-form>
    </el-card>
    <el-dialog v-model="centerDialogVisible" title="员工信息二维码" width="350px" center>
      <QRcode width="100%" height="100%" :content="content" :load="false"></QRcode>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <Commitment ref="myComponent" @confirm="(val) => { }" /> <!-- 确定事件将结果通过@传递出来 -->
    <HireCondition ref="hireCondition" @confirm="(val) => { }" /> <!-- 确定事件将结果通过@传递出来 -->
    <InfoInstruct ref="infoInstruct" @confirm="(val) => { }" /> <!-- 确定事件将结果通过@传递出来 -->
    <!-- <div align="center" style="height:10px;"></div>
      <div align="center" style="color:#b4b4b4;font-size:16px;">员工信息二维码</div>
      <div align="center" style="height:10px;"></div>
      <div align="center"><div ref="divempqrcode" id="divempqrcode" style="height:245px;width:260px;padding-top:15px;border-style:dotted;border-width:1px;border-color:#b4b4b4;"></div></div>
      <div align="center" style="height:10px;"></div> -->
  </div>
</template>
  
<script>
import Commitment from '@/components/Commitment.vue';
import HireCondition from '@/components/HireCondition.vue';
import InfoInstruct from '@/components/InfoInstruct.vue';
import { setLocalStorageAndTime, getLocalStorageAndTime, deleteLocalStorage } from '../util/localStorage'
// import Base from '../assets/js/Base'
import PinyinMatch from 'pinyin-match'

export default {
  name: 'Recruit',
  components: {
    Commitment,
    HireCondition,
    InfoInstruct
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value && value != "") {
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validatePinyin = (rule, value, callback) => {
      if (value && value != "") {
        const pinyin = /^[A-Za-z]+$/;
        if (!pinyin.test(value)) {
          callback(new Error("只能输入字母"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateZifu = (rule, value, callback) => {
      if (value && value != "") {
        const zifu = /[$]/g;
        if (zifu.test(value)) {
          callback(new Error("不能输入特殊字符"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateIdentify = (rule, value, callback) => {
      if (value && value != "") {
        const regIdentify = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!regIdentify.test(value)) {
          callback(new Error("请输入合法的身份证号码"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      disabledDate(time) {
        return time.getTime() > Date.now(); //禁止选择今天以后的时间
        //return time.getTime() < Date.now() - 8.64e7;//禁止选择今天以前的时间
      },
      disabledBefor(time) {
        return time.getTime() < Date.now() - 8.64e7;//禁止选择今天以前的时间
      },
      sexs: [], //性别
      positions: [], // 职位
      nationalityOptions: [], //民族
      companies: [],//公司
      // native: [], //籍贯
      cities: [], //省 
      copycities: [],
      academics: [], //学历
      staff_academics: [], //员工学历
      position_academics: [], //职工学历
      eduMethods: [], //受教育方式
      consultings: [], //咨询信息
      marriages: [],  //婚姻状况
      computerSkills: [], //计算机水平
      checked1: false,
      checked2: false,
      addemployer: false,  //是否显示工作经历2
      addcollege: false,   //是否显示毕业院校2
      addrelative: false,  // 是否显示家庭资料2
      centerDialogVisible: false,
      QRcodeWidth: 0,
      QRcodeHeight: 0,
      codeWidth: 0,
      content: {},
      form: {
        position: '',
        interViewDate: this.getdefaultDate('yyyyMMdd'),
        name: '',
        pinyin: '',
        sex: '',
        nationality: '',
        marriage: '',
        birthDay: '',
        height: null,
        vision: null,
        native: '',
        partyMember: '',
        blindness: '',
        contactAddress: '',
        phone: '',
        identifyNum: '',
        dispatchCompany: '',
        identifyAddr: '',
        startEnd1: '',
        start1: '',
        end1: '',
        college1: '',
        major1: '',
        academic1: '',
        eduMethod1: '',
        startEnd2: '',
        start2: '',
        end2: '',
        college2: '',
        major2: '',
        academic2: '',
        eduMethod2: '',
        languageLevel: '',
        computerSkill: '',
        certificate: '',
        workstartEnd1: '',
        workStart1: '',
        workEnd1: '',
        employer1: '',
        position1: '',
        salary1: null,
        reason1: '',
        provers1: '',
        workstartEnd2: '',
        workStart2: '',
        workEnd2: '',
        employer2: '',
        position2: '',
        salary2: null,
        reason2: '',
        provers2: '',
        hopeSalary: null,
        workDate: '',
        relativeName1: '',
        relation1: '',
        relativeAddress1: '',
        relativePhone1: '',
        relativeName2: '',
        relation2: '',
        relativeAddress2: '',
        relativePhone2: '',
        emergencyName: '',
        emergencyrelation: '',
        emergencyAddress: '',
        emergencyPhone: '',
        consulting: [],
        remark: '',
        createDate: '',
      },
      rules: {
        position: [
          { required: true, message: '请选择申请职位', trigger: 'change' },
          // { max: 10, message: '长度在10个字符内', trigger: 'blur' }
        ],
        interViewDate: [
          { required: true, message: '请选择面试日期', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        pinyin: [
          { required: true, message: '请输入拼音', trigger: 'change' },
          { validator: validatePinyin, trigger: 'change' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        nationality: [
          { required: true, message: '请选择民族', trigger: 'change' },
        ],
        marriage: [
          { required: true, message: '请选择婚姻状况', trigger: 'change' },
        ],
        // birthDay: [
        //   { required: true, message: '请选择生日日期', trigger: 'change' },

        // ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'change' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'change' },
          { min: 10, max: 50, message: '长度在10~50个字符之间', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        dispatchCompany: [
          { required: true, message: '请选择派遣公司', trigger: 'change' }
        ],
        native: [
          { required: true, message: '请选择籍贯', trigger: 'change' },
          { max: 20, message: '长度在20个字符内', trigger: 'change' }
        ],
        identifyNum: [
          { required: true, message: '请输入身份证号码', trigger: 'change' },
          { validator: validateIdentify, trigger: 'change' }
        ],
        identifyAddr: [
          { required: true, message: '请输入身份证地址', trigger: 'change' },
          { min: 10, max: 50, message: '长度在10~50个字符之间', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        languageLevel: [
          { required: true, message: '请输入外语水平', trigger: 'change' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        computerSkill: [
          { required: true, message: '请选择计算机水平', trigger: 'change' },
          // { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          // { validator: validateZifu, trigger: 'change' }
        ],
        certificate: [
          { required: true, message: '请输入资格证书', trigger: 'change' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        college1: [
          { required: true, message: '请输入毕业院校', trigger: 'change' },
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        // startEnd1: [
        //   { required: true, message: '请选择起止日期', trigger: 'change' },
        // ],
        start1: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (this.form.end1 && value > this.form.end1) {
                callback(new Error("开始日期不能晚于结束日期"));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'change' 
          }
        ],
        end1: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (this.form.start1 && value < this.form.start1) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            },
            trigger: 'change' 
          }
        ],
        major1: [
          { required: true, message: '请输入专业', trigger: 'change' },
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        academic1: [
          { required: true, message: '请选择学历', trigger: 'change' },
        ],
        eduMethod1: [
          { required: true, message: '请选择受教育方式', trigger: 'change' },
        ],
        college2: [
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        major2: [
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        hopeSalary: [
          { required: true, message: '请输入希望薪金', trigger: 'change' },
        ],
        workDate: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
        employer1: [
          { required: true, message: '请输入工作单位', trigger: 'change' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        // workstartEnd1: [
        //   { required: true, message: '请选择起止日期', trigger: 'change' },
        // ],
        workStart1: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (this.form.workEnd1 && value > this.form.workEnd1) {
                callback(new Error("开始日期不能晚于结束日期"));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'change' 
          }
        ],
        workEnd1: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (this.form.workStart1 && value < this.form.workStart1) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            },
            trigger: 'change' 
          }
        ],
        position1: [
          { required: true, message: '请输入职务', trigger: 'change' },
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        salary1: [
          { required: true, message: '请输入薪金', trigger: 'change' },
        ],
        reason1: [
          { required: true, message: '请输入离职原因', trigger: 'change' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        provers1: [
          { required: true, message: '请输入证明人及联系方式', trigger: 'change' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],

        relativeName1: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relation1: [
          { required: true, message: '请输入关系', trigger: 'change' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relativeAddress1: [
          { required: true, message: '请输入联系地址', trigger: 'change' },
          { min: 10, max: 50, message: '长度在10~50个字符之间', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relativePhone1: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        employer2: [
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        position2: [
          { max: 20, message: '长度在20个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        reason2: [
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        provers2: [
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relativeName2: [
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relation2: [
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        relativePhone2: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        relativeAddress2: [
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        emergencyName: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        emergencyrelation: [
          { required: true, message: '请输入关系', trigger: 'change' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        emergencyAddress: [
          { required: true, message: '请输入联系地址', trigger: 'change' },
          { min: 10, max: 50, message: '长度在10~50个字符之间', trigger: 'blur' },
          { validator: validateZifu, trigger: 'change' }
        ],
        emergencyPhone: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        consulting: [
          // { type: 'array', required: true, message: '请至少选择一个咨询信息', trigger: 'change' }
          { required: true, message: '请选择一个咨询信息', trigger: 'change' }
        ],

        start2: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.end2 && value > this.form.end2) {
                callback(new Error("开始日期不能晚于结束日期"));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'change' 
          }
        ],
        end2: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.start2 && value < this.form.start2) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            },
            trigger: 'change' 
          }
        ],
        workStart2: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.workEnd2 && value > this.form.workEnd2) {
                callback(new Error("开始日期不能晚于结束日期"));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'change' 
          }
        ],
        workEnd2: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.workStart2 && value < this.form.workStart2) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            },
            trigger: 'change' 
          }
        ],
      }
    }
  },
  computed: {
    // 计算属性的 getter
    // 计算当前选中的position的id
    positionKey: function () {
      let obj = this.positions;
      let valueToFind = this.form.position;
      // `this` 指向 vm 实例
      let key = obj.find(key => key.name === valueToFind);
      return key ? key.id : undefined;
    },
    'form.startEnd1': function () {
      let result = this.form.start1 + ',' + this.form.end1
      return result
    },
    'form.startEnd2': function () {
      let result = this.form.start2 + ',' + this.form.end2
      return result
    },
    'form.workstartEnd1': function () {
      let result = this.form.workStart1 + ',' + this.form.workEnd1
      return result
    },
    'form.workstartEnd2': function () {
      let result = this.form.workStart2 + ',' + this.form.workEnd2
      return result
    }
  },
  created() {
    // 有数据再进行存储
    let recruitFrom = getLocalStorageAndTime('recruitForm', 86400000);
    if (recruitFrom) {
      this.form = recruitFrom;
      if (recruitFrom.start2 || recruitFrom.end2 || recruitFrom.college2 || recruitFrom.major2
        || recruitFrom.academic2 || recruitFrom.eduMethod2) {
        this.addcollege = true;
      }
      if (recruitFrom.workStart2||recruitFrom.workEnd2|| recruitFrom.employer2 || recruitFrom.position2
        || recruitFrom.salary2 || recruitFrom.reason2 || recruitFrom.provers2) {
        this.addemployer = true;
      }
      if (recruitFrom.relativeName2 || recruitFrom.relation2 || recruitFrom.relativeAddress2
        || recruitFrom.relativePhone2) {
        this.addrelative = true;
      }
    }

    this.$axios.get("./data.json").then((res) => {
      this.sexs = res.data.sexs;
      this.positions = res.data.positions;
      this.nationalityOptions = res.data.nationality;
      this.companies = res.data.companies;
      this.staff_academics = res.data.staff_academics;
      this.position_academics = res.data.position_academics
      // 根据职工类型选择不同的下拉框数据
      this.academics = this.positionKey == 1 ? this.staff_academics : this.position_academics;
      this.cities = res.data.cities;
      this.copycities = Object.assign(this.cities);
      this.eduMethods = res.data.eduMethods;
      this.consultings = res.data.consultings;
      this.marriages = res.data.marriages;
      this.computerSkills = res.data.computerSkills;
      // let newCities = JSON.parse(JSON.stringify(res.data.cities)) //数组是引用类型, 深拷贝一下
      // newCities.map(e => { 

      //   let children =JSON.parse(JSON.stringify(e.children));
      //   children.map(item =>{
      //     delete item.children;
      //   })
      //   e.children=children;
      // }); //然后删除属性children.children
      // this.native = newCities;
      // console.log(`this.cities = newCities;${JSON.stringify(newCities)}`);
    });
  },
  mounted() {

  },
  methods: {
    positionChange(){
        // 根据职工类型选择不同的下拉框数据
        this.academics = this.positionKey == 1 ? this.staff_academics : this.position_academics;
        this.form.academic1 = '';
        this.form.academic2 = '';
    },
    openCommitment(type) {
      if (type == "Commitment") {
        this.$refs.myComponent.show();
      } else if (type == "HireCondition") {
        this.$refs.hireCondition.show();
      } else if (type == "InfoInstruct") {
        this.$refs.infoInstruct.show();
      }
    },
    // 获取当前日期转化格式 yyyyMMdd
    getdefaultDate(type) {
      var date = new Date();
      var dateL = date.getFullYear().toString(); // 年
      var month = date.getMonth() + 1;
      if (month < 9) {
        month = '0' + month;
      }
      dateL += month.toString(); // 月
      var day = date.getDate();
      if (day < 9) {
        day = '0' + day;
      }
      dateL += day.toString();
      if (type == 'yyyyMMdd') {
        return dateL;
      } else { //yyyyMMddHHmmss
        let hour = date.getHours().toString().padStart(2, '0');
        let minute = date.getMinutes().toString().padStart(2, '0');
        let second = date.getSeconds().toString().padStart(2, '0');
        return `${dateL}${hour}${minute}${second}`;
      }


    },
    //根据身份证号码设置出生日期
    setBirthDay() {
      var num = this.form.identifyNum;
      if (num && num.length == 18) {
        this.form.birthDay = num.substring(6, 14);
        let age = this.getAgebyId(num);
        if (age < 18) {
          this.$message({
            showClose: true,
            message: '年龄不符合招聘要求！',
            type: 'error'
          });
        }
        return;
      }
      return;
    },
    //根据身份证号码求年龄
    getAgebyId(num) {
      //获取输入身份证号码 
      var UUserCard = num;
      //获取出生日期 
      UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
      // 获取年龄 
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
      if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
        age++;
      }
      //年龄 age
      return age;
    },
    SubmitEvent() {
      // this.content = JSON.stringify(this.form);
      // console.log(`KEY:${this.positionKey}`)
      // this.centerDialogVisible = true;
      // base64.js

      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.checked1 && this.checked2) {
            let age = this.getAgebyId(this.form.identifyNum);
            if (age < 18) {
              this.$message({
                showClose: true,
                message: '年龄不符合招聘要求！',
                type: 'error'
              });
              return;
            }
            this.form.createDate = this.getdefaultDate("yyyyMMdd");

            let formData = JSON.parse(JSON.stringify(this.form))
            delete formData.start1
            delete formData.end1
            delete formData.start2
            delete formData.end2
            delete formData.workStart1
            delete formData.workEnd1
            delete formData.workStart2
            delete formData.workEnd2
            formData.startEnd1 = this['form.startEnd1']
            formData.startEnd2 = this['form.startEnd2']
            formData.workstartEnd1 = this['form.workstartEnd1']
            formData.workstartEnd2 = this['form.workstartEnd2']
            // "专业"未填写时默认“/”
            if(formData.college1 &&!formData.major1){
              formData.major1 = '/';
            }
            if(formData.college2 && !formData.major2){
              formData.major2 = '/';
            }
            this.content = Object.values(formData).join('$');
            // this.content = JSON.stringify(this.form);
            // let basestr   = Base.encode(this.content);
            // console.log(`this.content :${this.content}`)
            // console.log(`base:${basestr}`)
            this.centerDialogVisible = true;
            // 提交后删除localStorage的表单数据
            deleteLocalStorage('recruitForm');
          } else {
            this.$message({
              showClose: true,
              message: '请勾选同意！',
              type: 'warning'
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: '请完善信息！',
            type: 'error'
          });
        }

      });

    },
    // 根据中文或拼音搜索
    pinyinFilterMethod(val) {
      // 对绑定数据赋值
      if (val) {
        this.cities = this.copycities.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.name) {
            if (item.name.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return PinyinMatch.match(item.name, val)
          }
        })
      } else {
        this.cities = this.copycities
      }
    },
    //中文编码转换
    UTF16ToUTF8(str) {
      var out, i, len, c;
      out = "";
      len = str.length;
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if ((c >= 0x0001) && (c <= 0x007F)) {
          out += str.charAt(i);
        } else if (c > 0x07FF) {
          out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        } else {
          out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        }
      }
      return out;
    },
    // 移除毕业院校2
    removeCollege() {
      this.addcollege = false;
      // this.form.startEnd2 = '';
      this.form.start2 = '';
      this.form.end2 = '';
      this.form.college2 = '';
      this.form.major2 = '';
      this.form.academic2 = '';
      this.form.eduMethod2 = '';
    },
    // 移除工作经历2
    removeEmployer() {
      this.addemployer = false;
      // this.form.workstartEnd2 = '';
      this.form.workStart2 = '';
      this.form.workEnd2 = '';
      this.form.employer2 = '';
      this.form.position2 = '';
      this.form.salary2 = '';
      this.form.reason2 = '';
      this.form.provers2 = '';
    },
    // 移除家庭资料2
    removeRelative() {
      this.addrelative = false;
      this.form.relativeName2 = '';
      this.form.relation2 = '';
      this.form.relativeAddress2 = '';
      this.form.relativePhone2 = '';
    },
  },
  watch: {
    'form.employer1'(val) {
      if (val == '无') {
        // this.rules.workstartEnd1[0].required = false;
        this.rules.workStart1[0].required = false;
        this.rules.workEnd1[0].required = false;
        this.rules.position1[0].required = false;
        this.rules.salary1[0].required = false;
        this.rules.reason1[0].required = false;
        this.rules.provers1[0].required = false;
      } else {
        // this.rules.workstartEnd1[0].required = true;
        this.rules.workStart1[0].required = true;
        this.rules.workEnd1[0].required = true;
        this.rules.reason1[0].required = true;
        this.rules.provers1[0].required = true;
        this.rules.position1[0].required = true;
        this.rules.salary1[0].required = true;
      }
    },
    'form.college1'(val) {
      if (val == '无') {
        // this.rules.startEnd1[0].required = false;
        this.rules.start1[0].required = false;
        this.rules.end1[0].required = false;
        this.rules.major1[0].required = false;
        this.rules.academic1[0].required = false;
        this.rules.eduMethod1[0].required = false;
      } else {
        // this.rules.startEnd1[0].required = true;
        this.rules.start1[0].required = true;
        this.rules.end1[0].required = true;
        this.rules.academic1[0].required = true;
        this.rules.eduMethod1[0].required = true;
        if (this.positionKey == 1) {
          this.rules.major1[0].required = false;
        } else {
          this.rules.major1[0].required = true;

        }
      }
    },
    positionKey(val) {
      // position为员工时，对应的positionKey为1，清除不需要的表单数据
      if (val == 1) {
        this.form.partyMember = '';
        this.form.languageLevel = '';
        this.form.computerSkill = '';
        this.form.certificate = null;
        this.form.hopeSalary = null;
        this.form.workDate = '';
        this.rules.major1[0].required = false;

      } else {
        if (this.form.college1 == '无') {
          this.rules.major1[0].required = false;
        }else{
          this.rules.major1[0].required = true;
        }
      }

    },
    form: {
      handler(newValue, oldValue) {
        // 保存表单数据
        setLocalStorageAndTime('recruitForm', newValue)
      },
      deep: true
    }
  }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.titleCss {
  width: 100%;
  height: 60px;
  margin-bottom: 15px;
  border-radius: 3px;
  color: #0D2EA0;
  // background-color: #F5F7FA; 
}

.forntCss {
  line-height: 60px;
  font-size: 1.5rem;
}

.form {
  margin: 0 auto;
  padding: 10px;
  width: 80%;
  text-align: center;
}

.checkboxCss .el-radio-group {
  text-align: left !important; //这个很关键，否则最后一行是居中状态
}


.checkboxCss .el-radio {
  margin-left: 0px !important;
  margin-right: 25px !important;
  width: 110px !important; //根据内容设置宽度
  padding-left: 0px !important;
  text-align: left !important; //这个很关键，否则每一行都是居中状态
}

@media screen and (max-width: 700px) {
  .picker-down .el-date-range-picker .el-picker-panel__body {
    min-width: 280px !important;
  }

  .picker-down .el-date-range-picker {
    width: 310px !important;
  }

  .picker-down .el-date-range-picker__content {
    float: none !important;
    width: 100% !important;
  }

  .scrollbar_css {
    height: 600px;
  }
}

@media screen and (min-width: 800px) {
  .diglog {
    width: 700px;
  }
}

/* 自定义数字输入框append  */
.mo-input--number {
  border: 1px solid #DCDFE6;
  width: 100%;
  display: flex;
  border-radius: 4px;

  .el-input-number--mini {
    flex: 1;
  }

  ::v-deep .el-input__inner {
    border: none !important;
  }
}

.define-append {
  width: 40px;
  display: inline-block;
  background: #F5F7FA;
  padding: 0px 3px;
  border-left: none;
  height: 32px;
  line-height: 32px;
  color: #909399;
  font-size: 12px;
  text-align: center;
}

.icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-label {
  margin-top: 5px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
}

.icon-container :hover {
  color: #409EFC;
  cursor: pointer;
}

/* 类名要对应回 name 的属性值 */
.moveCartoon-enter-active {
  animation: move 1s;
}

.moveCartoon-leave-active {
  animation: move 1s reverse;
}

@keyframes move {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translate(0);
  }
}
</style>
  